import { NavLink, Outlet } from 'react-router-dom';

import { userInfoAtom } from '~entities/auth';

import { Container } from '~shared/ui/layout';

import { useAtomValue } from 'jotai';

import { TableTab } from './table-tab/table-tab';

import { useLastVisitedTab } from '../lib/use-last-visited-tab';

export const TransactionsPage = () => {
  useLastVisitedTab();
  const userInfo = useAtomValue(userInfoAtom);

  return (
    <Container>
      <div className="box-border min-h-full w-full pb-16 pt-10">
        <h2 className="mb-10 mt-0 text-4xl font-bold">Transactions</h2>
        <div className="flex flex-row">
          <NavLink to="loans" className="text-black/80 no-underline">
            {({ isActive }) => (
              <TableTab isActive={isActive}>Signed&nbsp;loans</TableTab>
            )}
          </NavLink>
          {userInfo?.employeeRole !== 'STORE_MANAGER' && (
            <NavLink to="payments" className="text-black/80 no-underline">
              {({ isActive }) => (
                <TableTab isActive={isActive}>Payments</TableTab>
              )}
            </NavLink>
          )}
        </div>
        <div className="rounded-2xl bg-white p-8">
          <Outlet />
        </div>
      </div>
    </Container>
  );
};
